import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Book } from 'src/config/api/models/Book';

export interface BooksSlice {
  currentBook: Book | null;
  bookId: string;
}

const initialState: BooksSlice = {
  currentBook: null,
  bookId: '',
};

const bookmarkSlice = createSlice({
  name: 'books',
  initialState,
  reducers: {
    setCurrentBook: (state, action: PayloadAction<Book>) => {
      return { ...state, currentBook: action.payload };
    },
    setBookId: (state, action: PayloadAction<BooksSlice['bookId']>) => {
      return { ...state, bookId: action.payload };
    },
    resetCurrentBook: (state) => {
      return { ...state, currentBook: null };
    },
    resetBooks: () => initialState,
  },
});

export const { setCurrentBook, resetCurrentBook, resetBooks, setBookId } = bookmarkSlice.actions;

export const { reducer: booksReducer } = bookmarkSlice;
